import { z } from "zod";

export default () => z.object({
    lostReason: z.string().min(1),
});
